// 日常生活動作(ADL)長期変化.
import * as React from 'react';
import * as PropTypes from 'prop-types';
import TrainingGraphs, { DummyTrainingGraphs } from './common/TrainingGraphs';
import * as MoffAPI from '../constants/MoffAPI';
import { MDate, validateLongterm, getLongtermHistory } from '../utils/dateUtil';
import { Global } from '../utils/global';
import * as TrainingConst from '../constants/Training';

// 印刷ボタンのCSS.
const printCss: React.CSSProperties = {
  marginLeft: '80.9%',
  marginTop: '0.0%'
};

// エラーメッセージのCSS.
const getErrorMsgStyle = function(msg: string): React.CSSProperties {
  let style: React.CSSProperties = {
    color: 'red',
    textAlign: 'center',
  };

  // エラーがあれば変更.
  if (msg) {
    style.marginBottom = '10px';
  }

  return style;
};

interface AdlLongTermState {
  // エラーメッセージ.
  termErrorMessage: string;
  startDate: string;
  endDate: string;
}

interface AdlLongTermProps extends React.Props<{}> {
  moffAPIActions: any;

  mDate: MDate;

  // 前ページのユーザーID.
  userId: string;

  Loaded: boolean;

  longTermData?: any;
}

// 利用者一覧の表のフィールド表示用コンポーネント
export default class AdlLongTerm extends React.Component<AdlLongTermProps, AdlLongTermState> {
  mDate: MDate;
  termErrorMessage: string;

  // inputタグのref.
  refStartDate: HTMLInputElement | null;
  refEndDate: HTMLInputElement | null;

  constructor(props: AdlLongTermProps) {
    super(props);

    // 開始YYYY-MM
    let startYearMonth: string = '';
    // 終わりYYYY-MM
    let endYearMonth: string = '';

    if (Global.adlStartYearMonth && Global.adlEndYearMonth) {
      startYearMonth = Global.adlStartYearMonth;
      endYearMonth = Global.adlEndYearMonth;
    } else {
      // 開始.
      const preDate: MDate = new MDate();
      preDate.setPreMonth(2); // 2ヶ月前にする.

      // 終わり.
      const nowDate: MDate = new MDate();
      startYearMonth = preDate.getYearMonth();
      endYearMonth = nowDate.getYearMonth();
    }

    this.state = {
      // 日付がエラーか.
      termErrorMessage : '',
      // 開始と終わり.
      startDate: startYearMonth,
      endDate: endYearMonth,
    };

    // 最初に一回通信.
    this.runAPI(this.state.startDate, this.state.endDate);
  }

  static get contextTypes() {
    // 親のAdlコンポーネントと橋渡しするcontext.
    return {
      changeState: PropTypes.func
    };
  }

  shouldComponentUpdate(nextProps: AdlLongTermProps, nextState: AdlLongTermState): boolean {
    const propsDiff = nextProps === this.props;
    const stateDiff = nextState === this.state;
    return !(propsDiff && stateDiff);
  }

  componentWillMount() {
    this.mDate = this.props.mDate;
  }

  // 「戻る」をクリックしたときの処理
  handleBackClicked = () => {
    // 長期変化を見なくする.
    this.context.changeState(TrainingConst.DETAIL_STATE);
  }

  changeStart = () => {
    this.judge();
  }

  changeEnd = () => {
    this.judge();
  }

  judge = () => {
    let isValid: boolean = false;
    const startDate: string = this.refStartDate ? this.refStartDate.value.toString() : '';
    const endDate: string = this.refEndDate ? this.refEndDate.value.toString() : '';

    // ここにも反映しないとinputの中身が変わらない.
    this.setState(
      {
        startDate: startDate,
        endDate: endDate,
      }
    );

    // フォーマット: 2017-01
    // ※年と月の片方さえなければ空文字で判定される.
    // OK: start:2018-12 end:2018-12
    // BAD: start:2018-12 end:2018-11 or 1年以上.
    isValid = validateLongterm(startDate, endDate);

    if (isValid) {
      this.setState(
        {termErrorMessage: ''}
      );

      // ページ前後しても記録させるため.
      Global.adlStartYearMonth = startDate;
      Global.adlEndYearMonth = endDate;

      // 通信.
      this.runAPI(startDate, endDate);
    } else {
      this.setState(
        {termErrorMessage: '期間は1年以内で、正しく指定してください。'}
      );
    }
  }

  // 範囲内でAPIを叩く.
  runAPI(startDate: string, endDate: string) {
    // URLのパラメータ.
    const arr: string[] = getLongtermHistory(startDate, endDate);
    this.props.moffAPIActions.getLongTermData(MoffAPI.ADL_TYPE, this.props.userId, arr);
  }

  render() {
    return (
      <div>
        <section id="sec01">
          <a
            onClick={event => this.handleBackClicked()}
            className="btn btn-default"
            role="button"
          >
            戻る
          </a>
          <a
            href="#"
            onClick={event => {window.print(); return false; }}
            className="btn btn-default"
            role="button"
            style={printCss}
          >
            印刷 
          </a>

          <p style={getErrorMsgStyle(this.state.termErrorMessage)}>
            {this.state.termErrorMessage}
          </p>
          {/* 年月選択  */}
          <div className="calendarHeader">
            <div className="dateArea">
              <div id="SearchPeriod" className="btn right">
                <input
                  key={`start_${this.state.startDate}`}
                  ref={(startDate) => { this.refStartDate = startDate; }}
                  type="month"
                  name="start_date"
                  onChange={event => this.changeStart()}
                  value={this.state.startDate}
                />
                <span> から </span>
                <input
                  key={`end_${this.state.endDate}`}
                  ref={(endDate) => { this.refEndDate = endDate; }}
                  type="month"
                  name="end_date"
                  onChange={event => this.changeEnd()}
                  value={this.state.endDate}
                />
              </div>
            </div>
          </div>
        </section>
        {(this.props.Loaded && this.props.longTermData) ? 
          <div>
            <TrainingGraphs
              type={TrainingConst.TYPE.ADL}
              history={this.props.longTermData}
              mDate={this.mDate}
              isLongTerm={true}
            />
          </div>
          :
          <div>
            <DummyTrainingGraphs
              type={TrainingConst.TYPE.ADL}
              mDate={this.mDate}
              isLongTerm={true}
            />
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdlLongTerm.tsx